import React from 'react';
import computer from '../images/computer.png';
import Typewriter from 'typewriter-effect';
import resume from '../resume/english.pdf';

function Hero() {
  return (
    <>
      <div className="h-full w-full flex flex-col items-center lg:flex-row lg:justify-around">
        <div className="order-2 lg:order-1  xl:p-2 m-5 flex flex-col items-start">
          <div className="w-full flex flex-col mb-2 md:mb-4">
            <p className="text-xl block xl:text-2xl text-slate-100 mr-2">Hi there! I am</p>          
            <p className="text-lightGreen text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold 2xl:text-8xl">Joao Marco Matta</p>
          </div>
          <div className="w-full flex flex-col md:flex-row md:items-center mb-2 md:mb-4">
            <Typewriter
              options={{
                wrapperClassName: 'Typewriter__wrapper text-red-400 text-xl md:text-3xl xl:text-3xl font-bold 2xl:text-4xl',
                cursorClassName: 'Typewriter__cursor text-red-400 text-xl md:text-3xl xl:text-3xl font-bold 2xl:text-4xl',
                delay: 100,
              }}
              onInit={(typewriter) => {
                typewriter
                  .typeString('Fullstack Web Developer.')
                  .start();
              }}
            />
          </div>
          <p className="text-lg md:text-lg xl:text-xl text-slate-100 my-1 md:my-2 pb-6">I develop solutions for your problems and bring your ideas to life!</p>
          <a href={ resume } download="Joao Marco Matta resume">
            <button className="bg-lightGreen hover:bg-emerald-400 text-zinc-900 font-bold py-2 px-4 rounded inline-flex items-center justify-center self-center active:translate-y-1 transition duration-200">
              <svg className="fill-current w-4 h-4 mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M13 8V2H7v6H2l8 8 8-8h-5zM0 18h20v2H0v-2z"/></svg>
              <span>Download CV</span>
            </button>
          </a>
        </div>
        <img className="lg:order-1 lg:z-10 h-60 sm:h-72 md:h-80 lg:h-80 xl:h-2/4 md:mt-20 lg:mt-0" src={ computer } alt="a laptop illustration" />
      </div>
    </>
  );
}

export default Hero;
